import { JsonApiQuery } from '@nx-icilalune/data/access';
import { Agency } from '@nx-icilalune/data/icilalune/types';

export const homeSectionAgencyDetailQuery: JsonApiQuery = {
  queryId: 'homeSectionAgencyDetailQuery',
  type: Agency.type,
  filters: {
    isPublished: '1',
  },
};
